import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { OrganizationsPage } from '@features/admin/organizations';
import { useAdminOrganizationStore } from '@features/admin/organizations/useAdminOrganizationStore.ts';

const organizationTypeSchema = z.enum(['SUPPLIER', 'CLIENT']).optional();
// Zdrojová řada organizace (organizations.source_type) — ECIS = firmy jen z eCIS, NP = ze starého nákupního portálu.
const organizationSourceSchema = z.enum(['NP', 'ECIS']).optional();

const adminOrganizationsSearchSchema = z.object({
  q: z.string().optional(),
  type: organizationTypeSchema,
  source: organizationSourceSchema,
  // Smluvní (fakturační) skupina — contract_groups.id.
  contractGroupId: z.coerce.number().optional(),
  // Indexace do Elasticu: true = jen indexované, false = jen neindexované, chybí = všechny.
  // Přes preprocess, protože z.coerce.boolean() by z řetězce "false" udělalo true.
  indexed: z.preprocess(value => {
    if (value === true || value === 'true') return true;
    if (value === false || value === 'false') return false;
    return undefined;
  }, z.boolean().optional()),
  page: z.coerce.number().optional().default(1),
  size: z.coerce.number().optional().default(20),
});

export type AdminOrganizationsSearch = z.infer<typeof adminOrganizationsSearchSchema>;
export type OrganizationType = z.infer<typeof organizationTypeSchema>;
export type OrganizationSource = z.infer<typeof organizationSourceSchema>;

export const Route = createFileRoute('/admin/organizations/')({
  validateSearch: search => adminOrganizationsSearchSchema.parse(search),
  component: RouteComponent,
  beforeLoad: ctx => {
    const { q, type, indexed, source, contractGroupId, page, size } = ctx.search;
    useAdminOrganizationStore.getState().loadOrganizations({
      q,
      type,
      indexed,
      source,
      contractGroupId,
      page: page || 1,
      size: size || 20,
    });
  },
});

function RouteComponent() {
  return <OrganizationsPage />;
}
